"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PostPagination = /** @class */ (function (_super) {
    __extends(PostPagination, _super);
    function PostPagination(props) {
        var _this = _super.call(this, props) || this;
        _this.pageChanged = function (e) {
            _this.setState({
                currentPage: e.target.value
            });
            var element = document.querySelector('.post__categories');
            var bodyRect = document.body.getBoundingClientRect(), elemRect = element.getBoundingClientRect(), offset = elemRect.top - bodyRect.top;
            window.scrollTo({
                top: offset,
                left: 0,
                behavior: 'smooth',
            });
            _this.props.handler(e.target.value);
        };
        _this.renderPages = function () {
            var pages = [];
            for (var i = 0; i < _this.props.maxPages; i++) {
                if (_this.state.currentPage && i + 1 == _this.state.currentPage) {
                    pages.push(react_1.default.createElement("li", null,
                        react_1.default.createElement("p", { className: "post__page active" }, i + 1)));
                }
                else {
                    pages.push(react_1.default.createElement("li", null,
                        react_1.default.createElement("button", { disabled: _this.props.loading, className: "post__page", value: i + 1, onClick: _this.pageChanged }, i + 1)));
                }
            }
            return (react_1.default.createElement("ul", null, pages));
        };
        _this.state = {
            currentPage: _this.props.currentPage,
        };
        return _this;
    }
    PostPagination.prototype.render = function () {
        if (this.props.maxPages && this.props.maxPages !== 1) {
            return (react_1.default.createElement("div", { className: "post__pagination" }, this.renderPages()));
        }
    };
    PostPagination.defaultProps = {
        currentPage: 1,
    };
    return PostPagination;
}(react_1.default.Component));
exports.default = PostPagination;
